import { useEffect, useState } from "react";
import LocationTable from "../../../components/common/locationTable";
import LocationMapModal from "../../../components/common/locationMapModal";
import Button from "../../../components/common/button";
import {
  addBusinessLocation,
  deleteBusinessLocation,
  getBusinessLocations,
  updateBusinessLocation,
} from "../../../api/business";
import { message } from "antd";
import DeleteMemberModal from "../../../components/common/modalMember";
import { useSelector } from "react-redux";
const Location = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [render, setRender] = useState(false);
  const [address, setAddress] = useState();
  const [deleteModalId, setDeleteModalId] = useState(false);
  const [location, setLocation] = useState(null);

  const businessLocations = useSelector(
    (state) => state?.business?.business?.numberOfLocations
  );
  const businessMaxLocations = businessLocations ?? 1;

  const fetchBusinessLocations = async () => {
    const response = await getBusinessLocations();
    if (response) {
      setAddress(response);
    }
  };

  useEffect(() => {
    fetchBusinessLocations();
  }, [render]);

  const showModal = (status, data) => {
    data ? setSelectedData(data) : setSelectedData(null);
    setIsModalOpen(status);
  };
  const hideModal = (values) => {
    setIsModalOpen(false);
    handleSaveClick(values);
  };
  const handleLocationChange = (newLocation) => {
    setLocation(newLocation);
  };

  const handleSaveClick = async (values) => {
    const payload = {
      businessAddress: values?.address,
      city: values?.city,
      state: values?.state,
      businessLocation: {
        type: "Point",
        coordinates: [+location?.lng, +location?.lat],
      },
    };
    if (selectedData) {
      payload._id = selectedData?._id;
      const res = await updateBusinessLocation(payload);
      if (res) {
        setRender(!render);
        message.success("Location updated successfully");
      }
    } else {
      const res = await addBusinessLocation(payload);
      if (res) {
        setRender(!render);
        message.success("Business location added successfully!");
      }
    }
  };

  const handleClickDelete = (data) => {
    setDeleteModalId(data?._id);
  };

  const handleDelete = async () => {
    const res = await deleteBusinessLocation(deleteModalId);
    if (res) {
      setRender(!render);
      message.success("Location deleted successfully");
    }
    setDeleteModalId(false);
  };
  return (
    <div className="p-3">
      <div className="flex justify-between items-center mb-2">
        <div className="">
          <p className="text-[32px] font-bold mb-0">Locations</p>
          <p>You can only add up to {businessMaxLocations} location(s).</p>
        </div>
        {businessMaxLocations > address?.length && (
          <div data-testid="add-location-button">
            <Button
              title={"Add Location"}
              className="w-14 bg-primaryPurple"
              onClick={showModal}
            />
          </div>
        )}
      </div>
      <LocationTable
        data={address}
        openModal={showModal}
        deleteClick={handleClickDelete}
      />
      {isModalOpen && (
        <LocationMapModal
          onOk={hideModal}
          defaultValue={selectedData}
          onCancel={() => setIsModalOpen(false)}
          onLocationChange={handleLocationChange}
        />
      )}
      {deleteModalId && (
        <DeleteMemberModal
          title={"Delete Location"}
          onOk={handleDelete}
          onCancel={() => setDeleteModalId(false)}
          text={"Are you sure you want to delete this business location?"}
        />
      )}
    </div>
  );
};
export default Location;
